import { AddressModel } from "../../address.model";
import { BaseModel } from "../../base.model";

export class OpposingCounsel extends BaseModel{
    name: string = "";
    phoneNumber: string = "";
    address: AddressModel = new AddressModel();
    email: string = "";
}
